export enum DesignStatus {
    None = 'none' ,
    Approved = 'approved',
    Rejected = 'rejected'
}
